import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useGetImages from '../../../../../hooks/use-get-images';
import StatusMessage from '../../../../common/status-message';
import Content from '../../../../common/content';
import PaymentSecurityDebtCancellation from '../../../../common/payment-debt-cancellation';
import { ScreenWrapper } from '../subcomponents';
import triggerPaymentSecurityAnalytics from '../../../../../helpers/trigger-payment-security-analytics';
import { PAGE_NAME } from '../../../../../const/analytics';
const PendingEnrollment = () => {
    const { t } = useTranslation();
    const { requestInProgress } = useGetImages();
    useEffect(() => {
        triggerPaymentSecurityAnalytics({
            pageName: PAGE_NAME.PENDING_ENROLLMENT
        });
    }, []);
    return (_jsxs(ScreenWrapper, { children: [_jsx(StatusMessage, { id: "ps-pending-enrollment", title: t('pendingEnrollment.paymentRequestReceived'), description: t('pendingEnrollment.statusUpdate'), image: requestInProgress, hasExtraBottomSpace: true }), _jsx(Content, { children: _jsx(PaymentSecurityDebtCancellation, {}) })] }));
};
export default PendingEnrollment;
